import React, { Component } from 'react';
import $ from "jquery";
import config from "../config";
import {
    ModulesModal,
    SeriesModal,
    ChangePasswordModal,
    ChangeDataMITModal,
    AreYouAgreeModal,
    BusinessPartnerFields,
    ItemDataFields
} from "./index";
import '../css/responsive.css'

let configFields = {
    businessPartner: {
        // DATOS MAESTROS
        BPMD0: { id: "BPMD0", show: true, edit: true },
        BPMD1: { id: "BPMD1", show: true, edit: true },
        BPMD2: { id: "BPMD2", show: true, edit: true },
        BPMD3: { id: "BPMD3", show: true, edit: true },
        BPMD4: { id: "BPMD4", show: true, edit: true },
        BPMD5: { id: "BPMD5", show: true, edit: true },
        // GENERAL
        BPG0: { id: "BPG0", show: true, edit: true },
        BPG1: { id: "BPG1", show: true, edit: true },
        BPG2: { id: "BPG2", show: true, edit: true },
        BPG3: { id: "BPG3", show: true, edit: true },
        BPG4: { id: "BPG4", show: true, edit: true },
        // CONDICION DE PAGO
        BPC0: { id: "BPC0", show: true, edit: true },
        BPC1: { id: "BPC1", show: true, edit: true },
        BPC2: { id: "BPC2", show: true, edit: true },
        BPC3: { id: "BPC3", show: true, edit: true },
        BPC4: { id: "BPC4", show: true, edit: true },
        BPC5: { id: "BPC5", show: true, edit: true },
        BPC6: { id: "BPC6", show: true, edit: true },
        BPC7: { id: "BPC7", show: true, edit: true },
        BPC8: { id: "BPC8", show: true, edit: true },
        BPC9: { id: "BPC9", show: true, edit: true },
        BPC10: { id: "BPC10", show: true, edit: true },
        BPC11: { id: "BPC11", show: true, edit: true },
        // DIRECCION DE FACTURACION
        BPIA0: { id: "BPIA0", show: true, edit: true },
        BPIA1: { id: "BPIA1", show: true, edit: true },
        BPIA2: { id: "BPIA2", show: true, edit: true },
        BPIA3: { id: "BPIA3", show: true, edit: true },
        BPIA4: { id: "BPIA4", show: true, edit: true },
        BPIA5: { id: "BPIA5", show: true, edit: true },
        BPIA6: { id: "BPIA6", show: true, edit: true },
        BPIA7: { id: "BPIA7", show: true, edit: true },
        BPIA8: { id: "BPIA8", show: true, edit: true },
        BPIA9: { id: "BPIA9", show: true, edit: true },
        BPIA10: { id: "BPIA10", show: true, edit: true },
        BPIA11: { id: "BPIA11", show: true, edit: true },
        BPIA12: { id: "BPIA12", show: true, edit: true },
        // BPIA13:{id:"BPIA13",show:true,edit:true},  
        // DIRECCION DE ENTREGA
        BPDA0: { id: "BPDA0", show: true, edit: true },
        BPDA1: { id: "BPDA1", show: true, edit: true },
        BPDA2: { id: "BPDA2", show: true, edit: true },
        BPDA3: { id: "BPDA3", show: true, edit: true },
        BPDA4: { id: "BPDA4", show: true, edit: true },
        BPDA5: { id: "BPDA5", show: true, edit: true },
        BPDA6: { id: "BPDA6", show: true, edit: true },
        BPDA7: { id: "BPDA7", show: true, edit: true },
        BPDA8: { id: "BPDA8", show: true, edit: true },
        BPDA9: { id: "BPDA9", show: true, edit: true },
        BPDA10: { id: "BPDA10", show: true, edit: true },
        BPDA11: { id: "BPDA11", show: true, edit: true },
        BPDA12: { id: "BPDA12", show: true, edit: true },
        BPDA13: { id: "BPDA13", show: true, edit: true },
        BPDA14: { id: "BPDA14", show: true, edit: true },
        // PERSONA CONTACTO
        BPCP0: { id: "BPCP0", show: true, edit: true },
        BPCP1: { id: "BPCP1", show: true, edit: true },
        BPCP2: { id: "BPCP2", show: true, edit: true },
        BPCP3: { id: "BPCP3", show: true, edit: true },
        BPCP4: { id: "BPCP4", show: true, edit: true },
        BPCP5: { id: "BPCP5", show: true, edit: true },
        BPCP6: { id: "BPCP6", show: true, edit: true },
        BPCP7: { id: "BPCP7", show: true, edit: true },
        BPCP8: { id: "BPCP8", show: true, edit: true },
        BPCP9: { id: "BPCP9", show: true, edit: true },
        BPCP10: { id: "BPCP10", show: true, edit: true },
        BPCP11: { id: "BPCP11", show: true, edit: true },
        BPCP12: { id: "BPCP12", show: true, edit: true },
        BPCP13: { id: "BPCP13", show: true, edit: true },
        BPCP14: { id: "BPCP14", show: true, edit: true },
        BPCP15: { id: "BPCP15", show: true, edit: true },
        // FINANZAS
        BPF0: { id: "BPF0", show: true, edit: true },
        BPF1: { id: "BPF1", show: true, edit: true },
        BPF2: { id: "BPF2", show: true, edit: true },
        BPF3: { id: "BPF3", show: true, edit: true },
        BPF4: { id: "BPF4", show: true, edit: true },
        BPF5: { id: "BPF5", show: true, edit: true },
        BPF6: { id: "BPF6", show: true, edit: true },
    },
    itemData: {

        IDMD0: { id: "IDMD0", show: true, edit: true },
        IDMD1: { id: "IDMD1", show: true, edit: true },
        IDMD2: { id: "IDMD2", show: true, edit: true },
        IDMD3: { id: "IDMD3", show: true, edit: true },
        IDMD4: { id: "IDMD4", show: true, edit: true },
        IDMD5: { id: "IDMD5", show: true, edit: true },
        IDMD6: { id: "IDMD6", show: true, edit: true },
        IDMD7: { id: "IDMD7", show: true, edit: true },

        IDSD0: { id: "IDSD0", show: true, edit: true },
        IDSD1: { id: "IDSD1", show: true, edit: true },
        IDSD2: { id: "IDSD2", show: true, edit: true },
        IDSD3: { id: "IDSD3", show: true, edit: true },
        IDSD4: { id: "IDSD4", show: true, edit: true },


        IDPD0: { id: "IDPD0", show: true, edit: true },
        IDPD1: { id: "IDPD1", show: true, edit: true },
        IDPD2: { id: "IDPD2", show: true, edit: true },
        IDPD3: { id: "IDPD3", show: true, edit: true },
        // IDPD4:{id:"IDPD4",show:true,edit:true},

        IDIA0: { id: "IDIA0", show: true, edit: true },
        IDIA1: { id: "IDIA1", show: true, edit: true },
        // IDIA2:{id:"IDIA2",show:true,edit:true},

        IDDA0: { id: "IDDA0", show: true, edit: true },
        IDDA1: { id: "IDDA1", show: true, edit: true },
        // IDDA2:{id:"IDDA2",show:true,edit:true},
    }
}

const defaultConfig = {
    edit_BPC0: true,
    edit_BPC1: true,
    edit_BPC2: true,
    edit_BPC3: true,
    edit_BPC4: true,
    edit_BPC5: true,
    edit_BPC6: true,
    edit_BPC7: true,
    edit_BPC8: true,
    edit_BPC9: true,
    edit_BPC10: true,
    edit_BPC11: true,
    edit_BPCP0: true,
    edit_BPCP1: true,
    edit_BPCP2: true,
    edit_BPCP3: true,
    edit_BPCP4: true,
    edit_BPCP5: true,
    edit_BPCP6: true,
    edit_BPCP7: true,
    edit_BPCP8: true,
    edit_BPCP9: true,
    edit_BPCP10: true,
    edit_BPCP11: true,
    edit_BPCP12: true,
    edit_BPCP13: true,
    edit_BPCP14: true,
    edit_BPCP15: true,

    edit_BPDA0: true,
    edit_BPDA1: true,
    edit_BPDA2: true,
    edit_BPDA3: true,
    edit_BPDA4: true,
    edit_BPDA5: true,
    edit_BPDA6: true,
    edit_BPDA7: true,
    edit_BPDA8: true,
    edit_BPDA9: true,
    edit_BPDA10: true,
    edit_BPDA11: true,
    edit_BPDA12: true,
    edit_BPDA13: true,

    edit_BPDM0: true,
    edit_BPF0: true,
    edit_BPF1: true,
    edit_BPF2: true,
    edit_BPF3: true,
    edit_BPF4: true,
    edit_BPF5: true,
    edit_BPG0: true,
    edit_BPG1: true,
    edit_BPG2: true,
    edit_BPG3: true,
    edit_BPG4: true,

    edit_BPIA0: true,
    edit_BPIA1: true,
    edit_BPIA2: true,
    edit_BPIA3: true,
    edit_BPIA4: true,
    edit_BPIA5: true,
    edit_BPIA6: true,
    edit_BPIA7: true,
    edit_BPIA8: true,
    edit_BPIA9: true,
    edit_BPIA10: true,
    edit_BPIA11: true,
    edit_BPIA12: true,

    show_BPDM0: true,
    edit_BPMD1: true,
    edit_BPMD2: true,
    edit_BPMD3: true,
    edit_BPMD4: true,
    edit_BPMD5: true,

    edit_BPUF0: true,
    edit_BPUF1: true,
    edit_BPUF2: true,
    edit_BPUF3: true,
    edit_BPUF4: true,
    edit_BPUF5: true,

    show_BPC0: true,
    show_BPC1: true,
    show_BPC2: true,
    show_BPC3: true,
    show_BPC4: true,
    show_BPC5: true,
    show_BPC6: true,
    show_BPC7: true,
    show_BPC8: true,
    show_BPC9: true,
    show_BPC10: true,
    show_BPC11: true,

    show_BPCP0: true,
    show_BPCP1: true,
    show_BPCP2: true,
    show_BPCP3: true,
    show_BPCP4: true,
    show_BPCP5: true,
    show_BPCP6: true,
    show_BPCP7: true,
    show_BPCP8: true,
    show_BPCP9: true,
    show_BPCP10: true,
    show_BPCP11: true,
    show_BPCP12: true,
    show_BPCP13: true,
    show_BPCP14: true,
    show_BPCP15: true,

    show_BPDA0: true,
    show_BPDA1: true,
    show_BPDA2: true,
    show_BPDA3: true,
    show_BPDA4: true,
    show_BPDA5: true,
    show_BPDA6: true,
    show_BPDA7: true,
    show_BPDA8: true,
    show_BPDA9: true,
    show_BPDA10: true,
    show_BPDA11: true,
    show_BPDA12: true,
    show_BPDA13: true,

    show_BPF0: true,
    show_BPF1: true,
    show_BPF2: true,
    show_BPF3: true,
    show_BPF4: true,
    show_BPF5: true,

    show_BPG0: true,
    show_BPG1: true,
    show_BPG2: true,
    show_BPG3: true,
    show_BPG4: true,

    show_BPIA0: true,
    show_BPIA1: true,
    show_BPIA2: true,
    show_BPIA3: true,
    show_BPIA4: true,
    show_BPIA5: true,
    show_BPIA6: true,
    show_BPIA7: true,
    show_BPIA8: true,
    show_BPIA9: true,

    show_BPIA10: true,
    show_BPIA11: true,
    show_BPIA12: true,
    show_BPMD1: true,

    show_BPMD2: true,
    show_BPMD3: true,
    show_BPMD4: true,
    show_BPMD5: true,
    show_BPUF0: true,
    show_BPUF1: true,
    show_BPUF2: true,
    show_BPUF3: true,
    show_BPUF4: true,
    show_BPUF5: true,
}

class AdministratorUsersModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            itemsDashboard: JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard')),
            checkboxDataTables: (new Map()),
            tokenVisibility: true,
            typeVisibility: true,
            typeVisibilityMIT: true,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
            showModulesModal: false,
            showSeriesModal: false,
            showChangePasswordModal: false,
            showAreYouAgreeModal: false,
            property: '',
            inputSucursalValue: undefined,

        };

        this.newModelCopy = '';
    };

    componentDidMount = () => {
        this._handelBack();
    };


    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    openAction = () => {
        $('#adminUsersModal').on('hide.bs.modal', function () {
        });
    };

    closeModal = () => {
        const { closeAdministratoruserModal } = this.props
        $('#adminUsersModal').modal('hide');
        this.setState({
            typeVisibility: true,
            typeVisibilityMIT: true,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
            showModulesModal: false,
            showSeriesModal: false,
            showChangePasswordModal: false,
            showAreYouAgreeModal: false,
            inputSucursalValue: undefined,

        });
        closeAdministratoruserModal();

    };

    sendModel = async () => {
        const { sendModel, adminUsersModel } = this.props;

        sendModel(adminUsersModel);

        this.setState({
            typeVisibility: true,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
            showModulesModal: false,
            showSeriesModal: false,
            showChangePasswordModal: false,
            showAreYouAgreeModal: false,
            inputSucursalValue: undefined,
        });
    };

    acceptEditMode = () => {
        const { acceptEditMode, adminUsersModel } = this.props;
        acceptEditMode(adminUsersModel);
        this.setState({
            typeVisibility: true,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
            showModulesModal: false,
            showSeriesModal: false,
            showChangePasswordModal: false,
            showAreYouAgreeModal: false,
            inputSucursalValue: undefined,
        });
    };

    cancelEditMode = () => {
        const { cancelEditMode } = this.props;
        cancelEditMode();
        this.setState({
            editMode: false,
            typeVisibility: true,
            typeVisibilityMIT: true,
            typeVisibilityOld: true,
            typeVisibilitynew: true,
            typeVisibilityconfirm: true,
            showModulesModal: false,
            showSeriesModal: false,
            showChangePasswordModal: false,
            showAreYouAgreeModal: false,
            inputSucursalValue: undefined,
        });
    };

    editMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };

    refreshModel = adminUsersModel => {
        const { refreshModel } = this.props;
        refreshModel(adminUsersModel);
    };

    //#region HEADER
    ChangeUser_Code = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.USER_CODE = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_Name = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_NAME = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeE_Mail = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.E_Mail = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_FMB_CC = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_CC = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_FMB_Role = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_role = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_FMB_CounterRol = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_CounterRol = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeCounterPermissionPrices = () => {
        const { adminUsersModel } = this.props;
        adminUsersModel.CounterPermission.EditPrice = !adminUsersModel.CounterPermission.EditPrice;
        this.refreshModel(adminUsersModel);
    };

    ChangeUsoInternoCCP = () => {
        const { adminUsersModel } = this.props;
        adminUsersModel.CCP_UsoInterno = adminUsersModel.CCP_UsoInterno && adminUsersModel.CCP_UsoInterno === 'Y' ? 'N' : 'Y';
        this.refreshModel(adminUsersModel);
    };

    ChangeCounterPermissionDiscounts = (value) => {

        const { adminUsersModel } = this.props;
        adminUsersModel.CounterPermission.EditDiscount = !adminUsersModel.CounterPermission.EditDiscount;
        this.refreshModel(adminUsersModel);
    };

    ChangeBranchPermission = (permission = "", value = false) => {
        const { adminUsersModel } = this.props;
        adminUsersModel.BranchPermission[permission] = value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_FMB_Passwd = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_passwd = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeMITUserCrypt = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.user_MIT = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeMITPasswordCrypt = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.pass_MIT = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    EyeVisibility = async () => {
        const { adminUsersModel, showPassword } = this.props;
        const { typeVisibility } = this.state;
        if (typeVisibility) { await showPassword(adminUsersModel.USERID); }
        this.setState({
            typeVisibility: !typeVisibility
        })
    };

    TokenVisibility = async () => {
        const { adminUsersModel, refreshToken } = this.props;
        const { tokenVisibility } = this.state;
        if (tokenVisibility) {
            await refreshToken(adminUsersModel.USERID);
        }
        this.setState({
            tokenVisibility: !tokenVisibility
        })
    };

    InfoToken = async () => {
        this.props.showAlert({ type: 'info', message: `Fecha de creación: ${this.props?.infoToken?.date ?? ''} a las ${this.props?.infoToken?.time ?? ''}`, timeOut: 5000 });
    }

    ChangeOldPassword = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.OldPassword = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    EyeVisibilityOld = async () => {
        const { typeVisibilityOld } = this.state;
        this.setState({
            typeVisibilityOld: !typeVisibilityOld
        })
    };

    ChangeU_FMB_PasswdNew = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_passwdNew = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    EyeVisibilityNew = async () => {
        const { typeVisibilitynew } = this.state;
        this.setState({
            typeVisibilitynew: !typeVisibilitynew
        })
    };

    ChangeU_FMB_Passwdconfirm = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_passwdConfirm = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    EyeVisibilityConfirm = async () => {
        const { typeVisibilityconfirm } = this.state;
        this.setState({
            typeVisibilityconfirm: !typeVisibilityconfirm
        })
    };

    ChangeU_FMB_Sucursal = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_Sucursal = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeCardCode = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_CardCode = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeActive = value => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_Active = value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_FMB_Caja = event => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_FMB_Caja = event.nativeEvent.target.value;
        this.refreshModel(adminUsersModel);
    };

    ChangeU_Discount = (value) => {
        const { adminUsersModel } = this.props;
        adminUsersModel.U_Discount = value;
        this.refreshModel(adminUsersModel);
    };

    //#endregion HEADER

    NameProperty = (property = null) => {
        let name = "";
        switch (property) {
            case 'invoice':
                name = "U_FMB_ValidateSeriesOINV";
                break;
            case 'quotations':
                name = "U_FMB_ValidateSeriesOQUT";
                break;
            case 'orderSales':
                name = "U_FMB_ValidateSeriesORDR";
                break;
            case 'deliveries':
                name = "U_FMB_ValidateSeriesODLN";
                break;
            case 'return':
                name = "U_FMB_ValidateSeriesORDN";
                break;
            case 'payment':
                name = "U_FMB_ValidateSeriesORCT";
                break;
            case 'transfers':
                name = "U_FMB_ValidateSeriesOWTR";
                break;
            case 'debitNote':
                name = "U_FMB_ValidateSeriesDN";
                break;
            case 'creditNote':
                name = "U_FMB_ValidateSeriesORIN";
                break;
            case 'transfersRequest':
                name = "U_FMB_ValidateSeriesOWTQ";
                break;
            case 'transfersEntry':
                name = "U_FMB_ValidateSeriesOIGN";
                break;
            case 'transfersOutput':
                name = "U_FMB_ValidateSeriesOIGE";
                break;
            case 'PurchaseOrder':
                name = "U_FMB_ValidateSeriesOPOR";
                break;
            case 'PurchaseRequest':
                name = "U_FMB_ValidateSeriesOPRQ";
                break;
            case 'purchaseReturn':
                name = "U_FMB_ValidateSeriesORPD";
                break;
            case 'inventoryRevaluation':
                name = "U_FMB_ValidateSeriesOMRV";
                break;
            case 'GoodsReceipt':
                name = "U_FMB_ValidateSeriesOPDN";
                break;
            case 'outgoingPayment':
                name = "U_FMB_ValidateSeriesOVPM";
                break;
            case 'purchaseInvoice':
                name = "U_FMB_ValidateSeriesOPCH";
                break;
            case 'purchaseCreditNotes':
                name = "U_FMB_ValidateSeriesORPC";
                break;
            default:
                name = "";
        }

        return { name }
    };

    OpenSeriesModal = async (serie, value) => {
        const { adminUsersModel, selectTable } = this.props;
        let table = selectTable(serie);
        let seriesNuevas = [];
        let selected = [];
        let nameProperty = this.NameProperty(serie);
        for (let index = 0; index < adminUsersModel.series.length; index++) {
            const element = adminUsersModel.series[index];
            if (element.ObjectCode === table.docType && element.DocSubType === table.docSubType) {
                seriesNuevas.push(element)
            }
        }

        if (value) {
            selected = value.split("|");
            for (let index = 0; index < selected.length; index++) {
                const idSerie = selected[index];
                for (let index = 0; index < seriesNuevas.length; index++) {
                    const pos = seriesNuevas[index];
                    if (pos.Series === parseInt(idSerie)) {
                        pos.selected = true;
                    }
                }
            }
        } else {
            for (let index = 0; index < seriesNuevas.length; index++) {
                const pos = seriesNuevas[index];
                pos.selected = false;
            }
        }
        adminUsersModel.newSeries = seriesNuevas;

        await this.setState({
            property: nameProperty.name,
            showSeriesModal: !this.state.showSeriesModal,
        });
        this.refreshModel(adminUsersModel);
        $('#seriesModal').modal('show');
    };

    CloseSeriesModal = async () => {
        $('#seriesModal').modal('hide');
        await this.setState({
            showSeriesModal: !this.state.showSeriesModal,
        });
    };

    OpenModulesModal = async () => {
        await this.setState({
            showModulesModal: !this.state.showModulesModal,
        });

        $('#modulesModal').modal('show');
    };

    CloseModulesModal = async () => {
        $('#modulesModal').modal('hide');

        await this.setState({
            showModulesModal: !this.state.showModulesModal,
        });
    };

    ToggleDocumentSelected = (id, type) => {
        const { adminUsersModel } = this.props;
        if (type === 1) {
            for (const key in adminUsersModel.itemsDashboard) {
                if (Object.hasOwnProperty.call(adminUsersModel.itemsDashboard, key)) {
                    const element = adminUsersModel.itemsDashboard[key];
                    if (element.tit === id.tit) {
                        element.active = !element.active;
                    }
                }
            }
            this.refreshModel(adminUsersModel);
        } else if (type === 2) {
            let newSeries = adminUsersModel.newSeries;
            newSeries[id].selected = !newSeries[id].selected;
            this.refreshModel(adminUsersModel);
        }
    };

    WriteAccessSelected = (id) => {
        const { adminUsersModel } = this.props;
        for (const key in adminUsersModel.itemsDashboard) {
            if (Object.hasOwnProperty.call(adminUsersModel.itemsDashboard, key)) {
                const element = adminUsersModel.itemsDashboard[key];
                if (element.tit === id.tit) {
                    element.Wr = !element.Wr;
                }
            }
        }
        this.refreshModel(adminUsersModel);
    };

    ToggleAllDocuments = (arrayModules, value) => {
        const { adminUsersModel } = this.props;
        for (const key in adminUsersModel.itemsDashboard) {
            if (Object.hasOwnProperty.call(adminUsersModel.itemsDashboard, key)) {
                const element = adminUsersModel.itemsDashboard[key];
                if (element.grp && element.tit !== 'Monedero Electrónico' && arrayModules.some(m => m.tit === element.tit)) {
                    element.active = value;
                }
            }
        }
        this.refreshModel(adminUsersModel);
    };

    WriteAllAccess = (arrayModules, value) => {
        const { adminUsersModel } = this.props;
        for (const key in adminUsersModel.itemsDashboard) {
            if (Object.hasOwnProperty.call(adminUsersModel.itemsDashboard, key)) {
                const element = adminUsersModel.itemsDashboard[key];
                if (element.grp && element.tit !== 'Monedero Electrónico' && arrayModules.some(m => m.tit === element.tit)) {
                    element.Wr = value;
                }
            }
        }
        this.refreshModel(adminUsersModel);
    };

    SaveModules = () => {
        const { adminUsersModel } = this.props;

        let itemsDashboard = adminUsersModel.itemsDashboard;
        // let modules = '';
        // for (let index = 0; index < itemsDashboard.length; index++) { //708
        //     const element = itemsDashboard[index];
        //     if(element.selected){
        //         modules += `${element.position}|`;
        //     }
        // }
        adminUsersModel.U_FMB_Modulos = itemsDashboard //modules;
        this.refreshModel(adminUsersModel);
        this.CloseModulesModal();
        $('#modulesModal').modal('hide');
    };

    SaveSeries = () => {
        const { adminUsersModel } = this.props;
        const { property } = this.state;
        let newSeries = adminUsersModel.newSeries;
        let series = '';
        for (let index = 0; index < newSeries.length; index++) {
            const element = newSeries[index];
            if (element.selected) {
                series += `${element.Series}|`;
            }
        }
        adminUsersModel[property] = series;
        this.refreshModel(adminUsersModel);
        this.CloseSeriesModal();
        $('#seriesModal').modal('hide');
    };

    OpenChangePasswordModal = async () => {
        await this.setState({
            showChangePasswordModal: !this.state.showChangePasswordModal,
        });

        $('#changePasswordModal').modal('show');
    };

    CloseChangePasswordModal = async () => {
        $('#changePasswordModal').modal('hide');

        await this.setState({
            showChangePasswordModal: !this.state.showChangePasswordModal,
        });
    };

    SaveChangePassword = async () => {
        const { adminUsersModel, changePassword } = this.props;
        changePassword(adminUsersModel);
    };

    OpenAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });

        $('#areYouAgreeModal').modal('show');
    };

    DeleteUser = async () => {
        const { adminUsersModel, deleteUser } = this.props;
        deleteUser(adminUsersModel);
    }

    SetWalletPermission = (event, module) => {
        const { adminUsersModel } = this.props
        const value = event.nativeEvent.target.checked;

        const auxModel = { ...adminUsersModel }
        const auxWalletPermissions = auxModel.walletPermissions.slice()
        const findIndex = auxWalletPermissions.findIndex((auxWallet) => auxWallet.idWalletPermissions === module.idWalletPermissions)

        if (findIndex != -1) {
            auxWalletPermissions[findIndex].Active = value ? 'Y' : 'N'
            auxModel.walletPermissions = auxWalletPermissions
            this.refreshModel(auxModel)
        }
    }
    refreshModel = adminUsersModel => {
        const { refreshModel } = this.props;
        refreshModel(adminUsersModel);
    };

    renderEditButton = () => {
        const { action, writeAccess } = this.props;
        const { editMode } = this.state;

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;

        if (!user || user.FMB_Role !== 'admin1') {
            return (
                <div>
                </div>
            )
        }
        if (action === 2 && !editMode && writeAccess) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    renderSucursales = () => {
        const { adminUsersModel, action, sucursales } = this.props;
        const { editMode, typeVisibilityMIT } = this.state;
        let ListPartner = [];
        if (sucursales.length > 0) {
            for (let index = 0; index < sucursales.length; index++) {
                const element = sucursales[index];
                if (Number(adminUsersModel.U_FMB_Sucursal) === element.pk_Sucursal) {
                    ListPartner = element.ListPartners
                }
            }
        }

        return (
            <>
                {/*SUCURSAL*/}
                <div className="input-group mb-3 position-relative">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={(action === 2 && !editMode) ? true : false}
                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                        value={this.state.inputSucursalValue !== undefined
                            ? this.state.inputSucursalValue
                            : (sucursales.find(s => s.pk_Sucursal === adminUsersModel.U_FMB_Sucursal)?.nombre || "")}
                        onChange={(e) => {
                            this.setState({
                                inputSucursalValue: e.target.value,
                                showSucursalList: true
                            });
                        }}
                        onFocus={() => this.setState({ showSucursalList: true })}
                        onBlur={() => {
                            // Limpia el input temporal si no se seleccionó nada
                            setTimeout(() => {
                                if (this.state.showSucursalList) {
                                    this.setState({ showSucursalList: false });
                                }
                            }, 200);
                        }}
                        placeholder="Escribe o selecciona sucursal"
                        autoComplete="off"
                    />
                    {this.state.showSucursalList && (
                        <ul
                            className="list-group position-absolute"
                            style={{
                                top: '100%',
                                left: 0,
                                right: 0,
                                maxHeight: '200px',
                                overflowY: 'auto',
                                zIndex: 1000,
                                marginTop: '2px'
                            }}
                        >
                            {sucursales
                                .filter(sucur => {
                                    const searchValue = this.state.inputSucursalValue || '';
                                    return sucur.nombre.toLowerCase().includes(searchValue.toLowerCase());
                                })
                                .map((sucur, index) => (
                                    <li
                                        key={'optionSuc' + index}
                                        className="list-group-item list-group-item-action"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            // Actualiza SOLO el modelo local, no el state
                                            adminUsersModel.U_FMB_Sucursal = sucur.pk_Sucursal;

                                            this.setState({
                                                inputSucursalValue: sucur.nombre,
                                                showSucursalList: false
                                            });
                                        }}
                                    >
                                        {sucur.nombre}
                                    </li>
                                ))
                            }
                        </ul>
                    )}
                </div>

                {(adminUsersModel.U_FMB_role === 'counter1' || adminUsersModel.U_FMB_role === 'admin1') &&
                    <>
                        {/*TIPO DE ROL COUNTER*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Counter rol</span>
                            </div>
                            <select
                                name="select"
                                className="form-control"
                                id="selectDocTypeDocumentSearch"
                                disabled={(action === 2 && !editMode) ? true : false}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                value={adminUsersModel.U_FMB_CounterRol ? adminUsersModel.U_FMB_CounterRol : ""}
                                onChange={this.ChangeU_FMB_CounterRol}>
                                <option value="---">Seleccione un rol</option>
                                <option value="counter">MOSTRADOR</option>
                                <option value="cashRegister">CAJA</option>
                                <option value="manager">GERENTE</option>
                                <option value="storer">ALMACÉN / INVENTARIO</option>
                            </select>
                        </div>
                        {/*CLIENTE POR DEFECTO*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                            </div>
                            <select
                                name="select"
                                className="form-control"
                                id="selectCaja"
                                disabled={(action === 2 && !editMode) ? true : false}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                value={adminUsersModel.U_CardCode || ""}
                                onChange={this.ChangeCardCode}>
                                <option value="---">Seleccionar</option>
                                {!!ListPartner && ListPartner.map((partner, index) => {
                                    return (
                                        <option key={'optionPartner' + index} value={partner.CardCode}>{partner.CardName || 'Sin nombre'}</option>
                                    )
                                })}
                            </select>
                        </div>


                    </>
                }

                {Number(action) !== 1 &&
                    <>

                        {/*USUARIO TERMINAL MIT*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Usuario MIT</span>
                            </div>
                            <input className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                type={typeVisibilityMIT === false ? 'text' : 'password'}
                                disabled={(action === 2) ? true : false}
                                onChange={this.ChangeMITUserCrypt}
                                autoComplete="new-password"
                                value={adminUsersModel.user_MIT ? typeVisibilityMIT === false ? adminUsersModel.user_MIT_decrypt : adminUsersModel.user_MIT : ""}
                            />
                            <div className="input-group-prepend" style={{ width: 40 }}>
                                <span className="input-group-text" style={{ background: '' }}
                                    onClick={() => this.EyeVisibilityMIT()}><i className={typeVisibilityMIT === false ? 'fa fa-eye' : 'fa fa-eye-slash'} /></span>
                            </div>
                        </div>

                        {/*CONTRASEÑA DE USUARIO TERMINAL MIT*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña MIT</span>
                            </div>
                            <input className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                type={typeVisibilityMIT === false ? 'text' : 'password'}
                                disabled={(action === 2) ? true : false}
                                onChange={this.ChangeMITPasswordCrypt}
                                autoComplete="new-password"
                                value={adminUsersModel.pass_MIT ? typeVisibilityMIT === false && action === 2 ? adminUsersModel.pass_MIT_decrypt : adminUsersModel.pass_MIT : ""}
                            />
                            <div className="input-group-prepend" style={{ width: 40 }}>
                                <span className="input-group-text" style={{ background: '' }}
                                    onClick={() => this.EyeVisibilityMIT()}><i className={typeVisibilityMIT === false ? 'fa fa-eye' : 'fa fa-eye-slash'} /></span>
                            </div>
                        </div>

                    </>

                }


                {/*CAMBIAR CONTRASEÑA*/}
                {(action === 2 && editMode) &&
                    <div className="input-group mb-3" style={{ justifyContent: 'space-around' }}>
                        <u onClick={() => this.OpenMITDataModal()}>Cambiar datos MIT</u>
                    </div>
                }

                {/*DESCUENTO DE SUCURSAL*/}
                {/* <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Descuento Sucursal %</span>
                    </div>
                    <input type="text" className="form-control"
                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        id="Sucur_Descuento"
                        disabled={true}
                        onChange={(event) => this.ChangeU_Discount(event.target.value)}
                        value={adminUsersModel.descuento || 0} />
                </div> */}



                <div className="input-group mb-3">
                    <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                        <div className="radio font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                            <label>
                                <input
                                    type="radio"
                                    name="optradio"
                                    disabled={(action === 2 && !editMode) ? true : false}
                                    checked={adminUsersModel.U_Active === 'Y' ? true : false}
                                    id="radio"
                                    onChange={() => this.ChangeActive('Y')}
                                    style={{ marginRight: '5px' }}
                                />{' '}
                                Empleado activo
                            </label>
                        </div>
                        <div className="radio font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                            <label>
                                <input
                                    type="radio"
                                    name="optradio"
                                    disabled={(action === 2 && !editMode) ? true : false}
                                    checked={adminUsersModel.U_Active === 'N' ? true : false}
                                    id="radio2"
                                    onChange={() => this.ChangeActive('N')}
                                    style={{ marginRight: '5px' }}
                                />{' '}
                                Empleado inactivo
                            </label>
                        </div>
                    </div>
                </div>

            </>
        )
    }

    renderJefeArea = () => {
        const { adminUsersModel, action, jefeArea } = this.props;
        const { editMode } = this.state;

        return (
            <>
                <div className="input-group mb-3 position-relative">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Jefe de área</span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        disabled={(action === 2 && !editMode) ? true : false}
                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                        value={this.state.inputJefeAreaValue !== undefined
                            ? this.state.inputJefeAreaValue
                            : (jefeArea.find(s => s.USERID === adminUsersModel.U_FMB_UserId)?.U_NAME || "")}
                        onChange={(e) => {
                            this.setState({
                                inputJefeAreaValue: e.target.value,
                                showJefeAreaList: true
                            });
                        }}
                        onFocus={() => this.setState({ showJefeAreaList: true })}
                        onBlur={() => {
                            // Limpia el input temporal si no se seleccionó nada
                            setTimeout(() => {
                                if (this.state.showJefeAreaList) {
                                    this.setState({ showJefeAreaList: false });
                                }
                            }, 200);
                        }}
                        placeholder="Escribe o selecciona el jefe de área"
                        autoComplete="off"
                    />
                    {this.state.showJefeAreaList && (
                        <ul
                            className="list-group position-absolute"
                            style={{
                                top: '100%',
                                left: 0,
                                right: 0,
                                maxHeight: '200px',
                                overflowY: 'auto',
                                zIndex: 1000,
                                marginTop: '2px'
                            }}
                        >
                            {jefeArea
                                .filter(jefe => {
                                    const searchValue = this.state.inputJefeAreaValue || '';
                                    return jefe.U_NAME.toLowerCase().includes(searchValue.toLowerCase());
                                })
                                .map((jefe, index) => (
                                    <li
                                        key={'optionJefAre' + index}
                                        className="list-group-item list-group-item-action"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            // Actualiza SOLO el modelo local, no el state
                                            adminUsersModel.U_FMB_UserId = jefe.USERID;

                                            this.setState({
                                                inputJefeAreaValue: jefe.U_NAME,
                                                showJefeAreaList: false
                                            });
                                        }}
                                    >
                                        {jefe.U_NAME}
                                    </li>
                                ))
                            }
                        </ul>
                    )}
                </div>

            </>
        )
    }

    renderAdminUsersHeader = () => {
        const { adminUsersModel, action, token } = this.props;
        const { editMode, typeVisibility, tokenVisibility } = this.state;
        return (
            <div className="row" style={{ paddingRight: 0 }} autoComplete="off">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*CÓDIGO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="User_USER_CODE"
                            disabled={action === 2 ? true : false}
                            onChange={this.ChangeUser_Code}
                            value={adminUsersModel.USER_CODE ? adminUsersModel.USER_CODE : ""} />
                    </div>

                    {/*NOMBRE DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="User_U_NAME"
                            disabled={(action === 2 && !editMode) ? true : false}//708
                            onChange={this.ChangeU_Name}
                            value={adminUsersModel.U_NAME ? adminUsersModel.U_NAME : ""} />
                    </div>

                    {/*CORREO DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correo</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            disabled={(action === 2 && !editMode) ? true : false}
                            id="User_E_Mail"
                            onChange={this.ChangeE_Mail}
                            value={adminUsersModel.E_Mail ? adminUsersModel.E_Mail : ""}
                        />
                    </div>

                    {/*DESCUENTO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Descuento Usuario %</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="User_Descuento"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={(event) => this.ChangeU_Discount(event.target.value)}
                            min={0}
                            value={adminUsersModel.U_Discount || ''} />
                    </div>

                    {/*MÓDULOS DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Módulos</span>
                        </div>
                        <button
                            type="button"
                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                            className="input-group-text"
                            onClick={() => this.OpenModulesModal()}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                    </div>

                    {/*CORREOS COPIA DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correo copia</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            disabled={(action === 2 && !editMode) ? true : false}
                            id="User_U_FMB_CC"
                            autoComplete='off'
                            onChange={this.ChangeU_FMB_CC}
                            value={adminUsersModel.U_FMB_CC ? adminUsersModel.U_FMB_CC : ""}
                        />
                    </div>

                    {/* COUNTER PERMISSIONS */}
                    <div className="input-group mb-2">
                        <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                            <h6>Permisos para counter</h6>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label'
                                        type="checkbox"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        checked={adminUsersModel.CounterPermission.EditPrice}
                                        id="radio"
                                        onChange={() => this.ChangeCounterPermissionPrices()}
                                        style={{ marginRight: '5px' }}
                                    />{' '}
                                    Editar precios counter
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        type="checkbox"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        checked={adminUsersModel.CounterPermission.EditDiscount}
                                        id="radio"
                                        onChange={(event) => this.ChangeCounterPermissionDiscounts()}
                                        style={{ marginRight: '5px' }}
                                    />{' '}
                                    Editar descuentos counter
                                </label>
                            </div>

                        </div>
                    </div>

                    {/* CARTA PORTE PERMISSIONS */}
                    <div className="input-group mb-2">
                        <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                            <h6>Permisos para Carta Porte</h6>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label'
                                        type="checkbox"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        checked={adminUsersModel.CCP_UsoInterno === 'Y'}
                                        id="radio"
                                        onChange={() => this.ChangeUsoInternoCCP()}
                                        style={{ marginRight: '5px' }}
                                    />{' '}
                                    Uso Interno
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* CARTA PORTE PERMISSIONS */}
                    <div className="input-group mb-2">
                        <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                            <h6>Permisos Adicionales</h6>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label mr-2'
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={adminUsersModel?.BranchPermission?.CloseDocuments ?? false}
                                        onChange={() => this.ChangeBranchPermission('CloseDocuments', !adminUsersModel?.BranchPermission?.CloseDocuments)} />
                                    Cerrar Documentos
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label mr-2'
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={adminUsersModel?.BranchPermission?.ProductionPrices ?? false}
                                        onChange={() => this.ChangeBranchPermission('ProductionPrices', !adminUsersModel?.BranchPermission?.ProductionPrices)} />
                                    Producción: Visualización de costos
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label mr-2'
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={adminUsersModel?.BranchPermission?.CancelClosePurchaseOrder ?? false}
                                        onChange={() => this.ChangeBranchPermission('CancelClosePurchaseOrder', !adminUsersModel?.BranchPermission?.CancelClosePurchaseOrder)} />
                                    Orden de compra: Cancelar y cerrar documento
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label mr-2'
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={adminUsersModel?.BranchPermission?.EditPurchaseOrder ?? false}
                                        onChange={() => this.ChangeBranchPermission('EditPurchaseOrder', !adminUsersModel?.BranchPermission?.EditPurchaseOrder)} />
                                    Orden de compra: Editar documento
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label mr-2'
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={adminUsersModel?.BranchPermission?.ChangeTaxRate ?? false}
                                        onChange={() => this.ChangeBranchPermission('ChangeTaxRate', !adminUsersModel?.BranchPermission?.ChangeTaxRate)} />
                                    Modificar código de impuesto
                                </label>
                            </div>

                            <div className="font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label mr-2'
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={adminUsersModel?.BranchPermission?.PendingCashCut ?? false}
                                        onChange={() => this.ChangeBranchPermission('PendingCashCut', !adminUsersModel?.BranchPermission?.PendingCashCut)} />
                                    Gestión Cortes
                                </label>
                            </div>

                        </div>
                    </div>

                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*TIPO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de usuario</span>
                        </div>
                        <select
                            name="select"
                            className="form-control"
                            id="selectDocTypeDocumentSearch"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={adminUsersModel.U_FMB_role ? adminUsersModel.U_FMB_role : ""}
                            onChange={this.ChangeU_FMB_Role}>
                            <option value="---">---</option>
                            <option value="branch1">BRANCH</option>
                            <option value="counter1">COUNTER</option>
                            <option value="admin1">ADMINISTRADOR</option>
                        </select>
                    </div>

                    {/*CONTRASEÑA DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña</span>
                        </div>
                        <input className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            type={typeVisibility === false ? 'text' : 'password'}
                            disabled={(action === 2) ? true : false}
                            onChange={this.ChangeU_FMB_Passwd}
                            autoComplete="new-password"
                            value={adminUsersModel.U_FMB_passwd ? typeVisibility === false && action === 2 ? adminUsersModel.U_FMB_passwdDecrypt : adminUsersModel.U_FMB_passwd : ""}
                        />
                        <div className="input-group-prepend" style={{ width: 40 }}>
                            <span className="input-group-text" style={{ background: '' }}
                                onClick={() => this.EyeVisibility()}><i className={typeVisibility === false ? 'fa fa-eye' : 'fa fa-eye-slash'} /></span>
                        </div>
                    </div>

                    {/*CAMBIAR CONTRASEÑA*/}
                    {(action === 2 && editMode) &&
                        <div className="input-group mb-3" style={{ justifyContent: 'space-around' }}>
                            <u onClick={() => this.OpenChangePasswordModal()}>Cambiar contraseña</u>
                        </div>
                    }

                    {/*Token de acceso*/}
                    {(action === 2) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Token de acceso
                                    {this.props.infoToken !== null &&
                                        <i className="fa fa-info-circle mt-2 ml-2" aria-hidden="true" onClick={() => this.InfoToken()}></i>
                                    }

                                </span>
                            </div>
                            <input className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                type={tokenVisibility === false ? 'text' : 'password'}
                                disabled={true}
                                value={token ? tokenVisibility === false ? token.twoStepsKeyDecrypt : token.twoStepsKey : ""}
                            />
                            <div className="input-group-prepend" style={{ width: 40 }}>
                                <span className="input-group-text" style={{ background: '' }}
                                    onClick={() => this.TokenVisibility()}><i className={tokenVisibility === false ? 'fa fa-eye' : 'fa fa-eye-slash'} /></span>
                            </div>
                        </div>
                    }

                    {/* CONF-COUNTER */}
                    {this.renderSucursales()}
                    {this.renderJefeArea()}
                </div>
                <br></br>
            </div>
        )
    };

    renderAdminUsersBody = () => {
        const { adminUsersModel, action, showAlert, userConfig, showBusinessPartnerFields } = this.props;
        const { activeF, prueba, editMode } = this.state
        let showMonederoTab = false
        for (const key in adminUsersModel.itemsDashboard) {
            if (Object.hasOwnProperty.call(adminUsersModel.itemsDashboard, key)) {
                const element = adminUsersModel.itemsDashboard[key];
                if (element.tit === 'Monedero Electrónico' && element.active) {
                    showMonederoTab = true
                }
            }
        }

        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Ventas"
                            data-toggle="tab"
                            href="#ModulosVentas"
                            role="modulosVentas"
                            aria-controls="DatosMaestrosSeries"
                            aria-selected="true">
                            Ventas
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-compras"
                            data-toggle="tab"
                            href="#ModulosCompras"
                            role="modulosCompras"
                            aria-controls="DatosMaestrosDirecciones"
                            aria-selected="false">
                            Compras
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Pagos"
                            data-toggle="tab"
                            href="#ModulosPagos"
                            role="modulosPagos"
                            aria-controls="DatosMaestrosDirecciones"
                            aria-selected="false">
                            Pagos
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Inventario"
                            data-toggle="tab"
                            href="#ModulosInventario"
                            role="modulosInventario"
                            aria-controls="DatosMaestrosDirecciones"
                            aria-selected="false">
                            Inventario
                        </a> */}
                        {/* {adminUsersModel.itemsDashboard.length > 0 && adminUsersModel.itemsDashboard[16].selected && */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-SocioNegocios"
                            data-toggle="tab"
                            href="#ModulosSociosDeNegocios"
                            role="modulosSociosDeNegocio"
                            aria-controls="DatosMaestrosSocioNegocios"
                            aria-selected="true">
                            Socio de Negocios
                        </a>
                        {/* } */}
                        {/* {adminUsersModel.itemsDashboard.length > 0 && adminUsersModel.itemsDashboard[17].selected && */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Articulos"
                            data-toggle="tab"
                            href="#ModulosArticulos"
                            role="modulosArticulos"
                            aria-controls="DatosMaestrosArticulos"
                            aria-selected="true">
                            Datos de artículos
                        </a>
                        {/* } */}
                        {showMonederoTab &&
                            <a
                                className="nav-item nav-link font-weight-bold text-secondary"
                                id="nav-profile-tab-Monedero"
                                data-toggle="tab"
                                href="#MonedeloElectTab"
                                role="tab"
                                aria-controls="MonedeloElectTab"
                                aria-selected="true">
                                Monedero Electrónico
                            </a>
                        }

                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* Ventas */}
                    {/* <div className="container tab-pane active" id="ModulosVentas" role="datosSeries" aria-labelledby="nav-profile-tab-Series">
                        <nav className='pl-3 pr-3 pt-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary active"
                                    id="nav-profile-tab-OfertaVenta"
                                    data-toggle="tab"
                                    href="#ofertaVenta"
                                    aria-controls="Inventario">
                                    Oferta de venta
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-OrdenVenta"
                                    data-toggle="tab"
                                    href="#ordenVenta"
                                    aria-controls="Operaciones">
                                    Orden de venta
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-Entrega"
                                    data-toggle="tab"
                                    href="#entrega"
                                    aria-controls="Generales">
                                    Entrega
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-Factura"
                                    data-toggle="tab"
                                    href="#factura"
                                    aria-controls="Funcionalidades">
                                    Factura
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-Facturareserva"
                                    data-toggle="tab"
                                    href="#facturaReserva"
                                    aria-controls="Otros">
                                    Factura Reserva
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-NotaDebito"
                                    data-toggle="tab"
                                    href="#notaDebito"
                                    aria-controls="Otros">
                                    Nota Debito
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-Devolucion"
                                    data-toggle="tab"
                                    href="#devolucion"
                                    aria-controls="Otros">
                                    Devolucion
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-NotaCredito"
                                    data-toggle="tab"
                                    href="#notaCredito"
                                    aria-controls="Otros">
                                    Nota Credito
                                </a>


                            </div>
                        </nav>
                        <div className="tab-content" style={{ textAlign: 'left', border: "1px solid" }}>
                            <div className="tab-pane active" id="ofertaVenta" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="ordenVenta" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="entrega" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="factura" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="facturaReserva" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="notaDebito" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="devolucion" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="notaCredito" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Compras */}
                    {/* <div className="container tab-pane" id="ModulosCompras" role="datosSocioNegocios" aria-labelledby="nav-profile-tab-SocioNegocios">
                        <nav className='pl-2 pr-2 pt-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary active"
                                    id="nav-profile-tab-SolicitudCompra"
                                    data-toggle="tab"
                                    href="#solicitudCompra"
                                    aria-controls="Inventario">
                                    Solicitud Compra
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-OrdenCompra"
                                    data-toggle="tab"
                                    href="#ordenCompra"
                                    aria-controls="Operaciones">
                                    Orden Compra
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-EntradMercancia"
                                    data-toggle="tab"
                                    href="#entradaMercancia"
                                    aria-controls="Generales">
                                    Entrada Mercancia
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-FacturaProvedores"
                                    data-toggle="tab"
                                    href="#facturaProvedores"
                                    aria-controls="Funcionalidades">
                                    Factura Proveedores
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-DevolucionMercancia"
                                    data-toggle="tab"
                                    href="#devolucionMercancia"
                                    aria-controls="Otros">
                                    Devolución Mercancia
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-NotaCreditoPro"
                                    data-toggle="tab"
                                    href="#notaCreditoPro"
                                    aria-controls="Otros">
                                    Credito Proveedores
                                </a>

                            </div>
                        </nav>
                        <div className="tab-content" style={{ textAlign: 'left', border: "1px solid" }}>
                            <div className="tab-pane active" id="solicitudCompra" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="ordenCompra" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="entradaMercancia" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="facturaProvedores" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="devolucionMercancia" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="notaCreditoPro" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Pagos */}
                    {/* <div className="container tab-pane" id="ModulosPagos" role="datosArticulos" aria-labelledby="nav-profile-tab-Articulos">
                        <nav className='pl-3 pr-3 pt-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary active"
                                    id="nav-profile-tab-PagosRecibidos"
                                    data-toggle="tab"
                                    href="#pagosRecibidos"
                                    aria-controls="Inventario">
                                    Pagos Recibidos
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-pagosEfectuados"
                                    data-toggle="tab"
                                    href="#pagosEfectuados"
                                    aria-controls="Operaciones">
                                    Pagos Efectuados
                                </a>
                            </div>
                        </nav>
                        <div className="tab-content" style={{ textAlign: 'left', border: "1px solid" }}>
                            <div className="tab-pane active" id="pagosRecibidos" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="pagosEfectuados" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Inventario */}
                    {/* <div className="container tab-pane" id="ModulosInventario" role="datosArticulos" aria-labelledby="nav-profile-tab-Articulos">
                        <nav className='pl-3 pr-3 pt-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary active"
                                    id="nav-profile-tab-SolTraslado"
                                    data-toggle="tab"
                                    href="#solTraslado"
                                    aria-controls="Inventario">
                                    Solicitud de Traslado
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-Traslado"
                                    data-toggle="tab"
                                    href="#traslado"
                                    aria-controls="Operaciones">
                                    Traslado de Mercancia
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-EntradaMerca"
                                    data-toggle="tab"
                                    href="#entradaMerca"
                                    aria-controls="Generales">
                                    Entrada de Mercancia
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-SalidaMerca"
                                    data-toggle="tab"
                                    href="#salidaMerca"
                                    aria-controls="Funcionalidades">
                                    Salida de Mercancia
                                </a>

                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary"
                                    id="nav-profile-tab-Revalorizacion"
                                    data-toggle="tab"
                                    href="#revalorizacion"
                                    aria-controls="Otros">
                                    Revalorizacion de Inventario
                                </a>
                            </div>
                        </nav>
                        <div className="tab-content" style={{ textAlign: 'left', border: "1px solid" }}>
                            <div className="tab-pane active" id="solTraslado" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="traslado" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="entradaMerca" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="salidaMerca" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="revalorizacion" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-6 p-3">

                                    </div>
                                    <div className="col-6 p-3">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Socios de negocios */}
                    <div className="container tab-pane active" id="ModulosSociosDeNegocios" role="datosArticulos" aria-labelledby="nav-profile-tab-Articulos">
                        {/* {adminUsersModel.USERID? this.setState({editMode: true}):""} */}
                        {showBusinessPartnerFields &&
                            <BusinessPartnerFields
                                adminUsersModel={adminUsersModel}
                                refreshModel={this.refreshModel}
                                configFields={configFields}
                                editMode={this.state.editMode}
                                action={action}
                                showAlert={showAlert}
                                userConfig={userConfig}
                            />

                        }


                    </div>

                    {/* Articulos  */}
                    <div className="container tab-pane" id="ModulosArticulos" role="datosArticulos" aria-labelledby="nav-profile-tab-Articulos">

                        <ItemDataFields
                            adminUsersModel={adminUsersModel}
                            refreshModel={this.refreshModel}
                            configFields={configFields}
                            editMode={this.state.editMode}
                            action={action}
                            showAlert={showAlert}
                        />
                    </div>
                    {showMonederoTab && <div className="container tab-pane" id="MonedeloElectTab" role="datosArticulos" aria-labelledby="nav-profile-tab-Articulos">
                        <div className='row mt-5' id="MonederoElectronico">
                            <div className="col-12 col-md-6">
                                {/* <h5 className='mb-4'>Opciones de Monedero Electrónico</h5> */}
                                <form>
                                    <div className="table-responsive">
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th className='text-center'>Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>Opciones de Monedero Electrónico</strong></td>
                                                </tr>
                                                {adminUsersModel.walletPermissions.map((module) => {
                                                    return (
                                                        <tr>
                                                            <td>{module.Name}</td>
                                                            <td className='text-center'>
                                                                <input
                                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                                    checked={module.Active == 'Y'}
                                                                    id={module.Key}
                                                                    type="checkbox"
                                                                    onChange={(event) => this.SetWalletPermission(event, module)} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>}

                </div>

            </div>
        )
    };

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
        });
    }

    //#region ######### MIT DATA ADITIONALS #########

    OpenChangeMITDataModal = async (action) => {
        $('#changeMITDataModal').modal(`${action}`);
    };

    OpenMITDataModal = async () => {
        const { adminUsersModel } = this.props
        this.OpenChangeMITDataModal('show');
        adminUsersModel.new_user_MIT = adminUsersModel.user_MIT_decrypt;
        adminUsersModel.new_pass_MIT = adminUsersModel.pass_MIT_decrypt;
        this.refreshModel(adminUsersModel);

    }

    CloseChangeMITDataModal = async () => {
        const { adminUsersModel } = this.props
        this.OpenChangeMITDataModal('hide');
        adminUsersModel.new_user_MIT = "";
        adminUsersModel.new_pass_MIT = "";
        this.refreshModel(adminUsersModel);

    }

    EyeVisibilityMIT = async () => {
        const { adminUsersModel, showPassword } = this.props;
        const { typeVisibilityMIT } = this.state;
        if (typeVisibilityMIT) { await showPassword(adminUsersModel.USERID); }
        this.setState({
            typeVisibilityMIT: !typeVisibilityMIT
        })
    };
    //#endregion



    render() {
        const {
            action,
            adminUsersModel,
            saveMITData
        } = this.props;
        const {
            editMode,
            checkboxDataTables,
            showModulesModal,
            showSeriesModal,
            showChangePasswordModal,
            typeVisibilityOld,
            typeVisibilitynew,
            typeVisibilityconfirm,
            showAreYouAgreeModal,
        } = this.state;

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.ToggleDocumentSelected,
            writeAccess: this.WriteAccessSelected,
            selectAll: this.ToggleAllDocuments,
            writeAll: this.WriteAllAccess,
        }

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="adminUsersModal"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                <ChangeDataMITModal
                    action={action}
                    editMode={editMode}
                    adminUsersModel={adminUsersModel}
                    CloseChangeMITDataModal={() => this.CloseChangeMITDataModal()}
                    SaveChangeData={saveMITData}
                    RefreshModel={this.refreshModel}
                />

                {showModulesModal &&
                    <ModulesModal
                        action={action}
                        adminUsersModel={adminUsersModel}
                        checkbox={checkbox}
                        editMode={editMode}
                        SaveModules={this.SaveModules}
                        CloseModulesModal={this.CloseModulesModal}
                    />
                }
                {showSeriesModal &&
                    <SeriesModal
                        action={action}
                        adminUsersModel={adminUsersModel}
                        checkbox={checkbox}
                        editMode={editMode}
                        SaveSeries={this.SaveSeries}
                        CloseSeriesModal={this.CloseSeriesModal}
                    />
                }
                {showChangePasswordModal &&
                    <ChangePasswordModal
                        action={action}
                        adminUsersModel={adminUsersModel}
                        editMode={editMode}
                        ChangeOldPassword={this.ChangeOldPassword}
                        ChangeU_FMB_PasswdNew={this.ChangeU_FMB_PasswdNew}
                        ChangeU_FMB_Passwdconfirm={this.ChangeU_FMB_Passwdconfirm}
                        EyeVisibilityOld={this.EyeVisibilityOld}
                        EyeVisibilityNew={this.EyeVisibilityNew}
                        EyeVisibilityConfirm={this.EyeVisibilityConfirm}
                        typeVisibilityOld={typeVisibilityOld}
                        typeVisibilitynew={typeVisibilitynew}
                        typeVisibilityconfirm={typeVisibilityconfirm}
                        SaveChangePassword={this.SaveChangePassword}
                        CloseChangePasswordModal={this.CloseChangePasswordModal}
                    />
                }
                {showAreYouAgreeModal &&
                    <AreYouAgreeModal
                        mensaje={'¿Estas seguro que deseas eliminar al vendedor?'}
                        accept={this.DeleteUser}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">{action === 1 ? 'NUEVO USUARIO' : 'USUARIO (detalle)'}</h4>
                            <button type="button" className="close" onClick={() => this.closeModal()} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            {this.renderEditButton()}
                                            {this.renderAdminUsersHeader()}
                                            {this.renderAdminUsersBody()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">

                            {action === 1 &&
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}>
                                    Crear
                                </button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger" onClick={this.OpenAreYouAgreeModal}>
                                    Eliminar
                                </button>
                            )}
                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.closeModal()}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
}

export default AdministratorUsersModal;